import React, {Component} from "react";
import {Card, Col, Row} from "react-bootstrap";
import {portfolioData, sectionHeaders} from "../../../data/data";

class About extends Component{
    render() {
        return (
            <div id={'about'}>
                <div className={'px-4 py-5 mt-5'}>
                    {sectionHeaders('about')}
                    <Row className={'py-5'}>
                        <Col md={5}>
                            <span style={{fontSize: '3em'}}><strong>A little about me</strong></span>
                        </Col>
                        <Col md={7} className={'py-3'} style={{fontSize: '1.2em', fontWeight: 500}} >
                            <div dangerouslySetInnerHTML={{__html: portfolioData.about.aboutInfo}}></div>
                        </Col>
                    </Row>
                </div>
            </div>
        );
    }
}

export default About;